import Accordion from './accordion';

export default class Content {
  constructor(app) {
    this.app = app;
    this.init();
  }

  init() {
    this.accordions = new Accordion(this);
  }

  destroy() {
    if (typeof this.accordions.destroy !== 'undefined') this.accordions.destroy();
  }
}



// WEBPACK FOOTER //
// ./scripts/components/content.js